__turbopack_context__.v({
  "body": "_7GMGhW_body",
  "bodySmall": "_7GMGhW_bodySmall",
  "error": "_7GMGhW_error",
  "green200": "_7GMGhW_green200",
  "green300": "_7GMGhW_green300",
  "green400": "_7GMGhW_green400",
  "green500": "_7GMGhW_green500",
  "headlineLarge": "_7GMGhW_headlineLarge",
  "headlineMedium": "_7GMGhW_headlineMedium",
  "headlineSmall": "_7GMGhW_headlineSmall",
  "label": "_7GMGhW_label",
  "mono1_300": "_7GMGhW_mono1_300",
  "mono1_400": "_7GMGhW_mono1_400",
  "mono2_300": "_7GMGhW_mono2_300",
  "o500": "_7GMGhW_o500",
  "r400": "_7GMGhW_r400",
  "r500": "_7GMGhW_r500",
  "r600": "_7GMGhW_r600",
  "title": "_7GMGhW_title",
  "titleLarge": "_7GMGhW_titleLarge",
  "titleMedium": "_7GMGhW_titleMedium",
  "titleSmall": "_7GMGhW_titleSmall",
  "turq300": "_7GMGhW_turq300",
  "turq400": "_7GMGhW_turq400",
  "turq500": "_7GMGhW_turq500",
  "white": "_7GMGhW_white",
});
